<template>
  <div v-if="value.meta">
    <el-divider />
      <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="">
        <el-input-title>Proof Of Age</el-input-title>
        <el-form-item prop="meta.proofOfAge">
          <el-input
            class="mt-05"
            disabled
            v-model="value.meta.proofOfAge"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <!-- <el-input-title>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-autocomplete
            class="mt-05"
            v-model="selectedName"
            :fetch-suggestions="searchClub"
            @select="handleSelect"
            placeholder="Enter club name to start searching"
          ></el-autocomplete>
        </el-form-item> -->
        <el-input-title required>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-select
            filterable
            remote
            reserve-keyword
            value-key="_id"
            class="mt-05 w-100"
            v-model="value.meta.homeClub"
            :remote-method="searchClub"
            placeholder="Select">
            <el-option
              v-for="{ _id, value } in clubs"
              :key="_id"
              :label="value"
              :value="{_id, value}">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-10">
        <el-input-title>Coaches Emails</el-input-title>
        <el-form-item prop="meta.coachesEmails">
          <el-tag
            class="mt-05 mr-05"
            :key="email"
            v-for="email in value.meta.coachesEmails"
            closable
            :disable-transitions="false"
            @close="handleClose(email)">
            {{email}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Email</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <!-- <el-input-title>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-autocomplete
            class="mt-05"
            v-model="selectedName"
            :fetch-suggestions="searchClub"
            @select="handleSelect"
            placeholder="Enter club name to start searching"
          ></el-autocomplete>
        </el-form-item> -->
        <el-input-title>Clubs</el-input-title>
        <el-form-item prop="meta.clubs">
          <el-select
            filterable
            multiple
            :multiple-limit=3
            remote
            @change="handleSelect"
            reserve-keyword
            class="mt-05 w-100"
            v-model="selectedClubs"
            :remote-method="searchClub"
            placeholder="Select">
            <el-option
              v-for="{ _id, value } in clubs"
              :key="_id"
              :label="value"
              :value="{ _id, value }">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  name: 'nswisaExtra',
  props: ['value'],
  data() {
    return {
      clubs: [],
      inputValue: '',
      inputVisible: false,
      selectedName: '',
      selectedClubs: []
    };
  },
  mounted() {
    if (this.value.meta && this.value.meta.homeClub) this.selectedName = this.value.meta.homeClub.name;
    if (this.value.meta && this.value.meta.clubs) this.selectedClubs = this.value.meta.clubs.map((club) => ({ _id: club._id, value: club.name }));
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
    handleSelect() {
      this.value.meta.clubs = this.selectedClubs.map((club) => ({ _id: club._id, name: club.value }));
    },
    handleClose(email) {
      this.value.meta.coachesEmails.splice(this.value.meta.coachesEmails.indexOf(email), 1);
    },
    showInput() {
      if (this.value.meta.coachesEmails.length >= 5) return this.$message.error('You can only have a maximum of 5 coaches emails');
      this.inputVisible = true;
      // eslint-disable-next-line no-unused-vars
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
      return false;
    },
    searchClub(query) {
      this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: query }).then((res) => {
        const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
        // Append none
        data.unshift({ value: 'None', _id: 'none' });
        this.clubs = data;
      }).catch(() => {});
    },
    handleInputConfirm() {
      const { inputValue } = this;
      if (inputValue) {
        const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        if (re.test(String(inputValue).toLowerCase())) this.value.meta.coachesEmails.push(inputValue);
        else return this.$message.error('Invalid Email');
      }
      this.inputVisible = false;
      this.inputValue = '';
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
